import { render, staticRenderFns } from "./dycommon.vue?vue&type=template&id=37e7de78&scoped=true"
import script from "./dycommon.vue?vue&type=script&lang=js"
export * from "./dycommon.vue?vue&type=script&lang=js"
import style0 from "./dycommon.vue?vue&type=style&index=0&id=37e7de78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e7de78",
  null
  
)

export default component.exports